import * as React from "react";
const SvgRibbon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 16V0h12v16h-2l-4-3-4 3z", clipRule: "evenodd" }));
export default SvgRibbon;
